export var AttendeeRibbonStatus;

(function (AttendeeRibbonStatus) {
  AttendeeRibbonStatus["Ongoing"] = "ongoing";
  AttendeeRibbonStatus["Submitted"] = "submitted";
  AttendeeRibbonStatus["Banned"] = "banned";
  AttendeeRibbonStatus["Failed"] = "failed";
  AttendeeRibbonStatus["Passed"] = "passed";
  AttendeeRibbonStatus["NotSubmitted"] = "notSubmitted";
  AttendeeRibbonStatus["Rejected"] = "rejected";
})(AttendeeRibbonStatus || (AttendeeRibbonStatus = {}));

export var AttendeeScoreMode;

(function (AttendeeScoreMode) {
  AttendeeScoreMode["Empty"] = "empty";
  AttendeeScoreMode["Grading"] = "grading";
  AttendeeScoreMode["Score"] = "score";
})(AttendeeScoreMode || (AttendeeScoreMode = {}));

export var resolveAttendeeMenuDisplay = function resolveAttendeeMenuDisplay(_ref) {
  var isBanned = _ref.isBanned,
      isRejected = _ref.isRejected,
      isGraded = _ref.isGraded,
      isSubmitted = _ref.isSubmitted,
      isExpired = _ref.isExpired,
      isOngoing = _ref.isOngoing,
      isGrading = _ref.isGrading,
      isPassed = _ref.isPassed,
      hasValidScore = _ref.hasValidScore;

  if (isBanned) {
    return {
      ribbonStatus: AttendeeRibbonStatus.Banned,
      showProgress: false,
      scoreMode: AttendeeScoreMode.Empty
    };
  }

  if (isRejected) {
    return {
      ribbonStatus: AttendeeRibbonStatus.Rejected,
      showProgress: false,
      scoreMode: AttendeeScoreMode.Score
    };
  }

  if (isGraded) {
    return {
      ribbonStatus: isPassed ? AttendeeRibbonStatus.Passed : AttendeeRibbonStatus.Failed,
      showProgress: true,
      scoreMode: AttendeeScoreMode.Score
    };
  }

  if (isSubmitted) {
    return {
      ribbonStatus: AttendeeRibbonStatus.Submitted,
      showProgress: false,
      scoreMode: isGrading ? AttendeeScoreMode.Grading : hasValidScore ? AttendeeScoreMode.Score : AttendeeScoreMode.Empty
    };
  }

  if (isExpired) {
    return {
      ribbonStatus: AttendeeRibbonStatus.NotSubmitted,
      showProgress: false,
      scoreMode: AttendeeScoreMode.Empty
    };
  }

  return {
    ribbonStatus: isOngoing ? AttendeeRibbonStatus.Ongoing : AttendeeRibbonStatus.Submitted,
    showProgress: false,
    scoreMode: AttendeeScoreMode.Empty
  };
};